/*eslint-disable*/
import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import React, { useEffect, useState } from 'react'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { dietaryPreferences } from './foodData'
import { IngredientsList } from './Food.styled'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { clearSingleDish, createDish, editDish, getSingleDish } from 'features/food/foodSlice'
import { standardFieldValidation, validateSelect } from 'utils/validationUtils'
import useModalClose from 'hooks/useModalClose'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { XIcon } from 'assets/icons/XIcon'

export const DishesModal = ({ closeModal, id }: { closeModal: any, id?: number }) => {
    const [state, setState] = useState<IDishesModal>({
        name: '',
        mealType: null,
        dietaryPreferences: [],
        supplier: null,
        ingredients: []
    })
    const [addingIngredient, setAddingIngredient] = useState({
        ingredient: null,
        amount: null,
    })
    const [invalidFields, setInvalidFields] = useState(id ? [] : ['name', 'mealType', 'supplier', 'dietaryPreferences'])
    const dispatch = useDispatch<AppDispatch>()
    const { singleDish } = useSelector((state: RootState) => state.food.dishes)

    useFocusFirstInput()
    useModalClose(closeModal)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        standardFieldValidation(e, setInvalidFields)
        setState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleSelect = (v: ISelectValue & { isConnectedWithFoodInventory?: boolean }, n: string) => {
        validateSelect(v, n, setInvalidFields)
        setState(prev => ({ ...prev, [n]: v }))
    }

    const handleIngredientSelect = (v: ISelectValue & { unit?: string }) => {
        setAddingIngredient(prev => ({ ...prev, ingredient: v }))
    }

    const handleAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddingIngredient(prev => ({ ...prev, [e.target.name]: e.target.valueAsNumber }))
    }

    const handleAddIngredient = () => {
        setState(prev => ({ ...prev, ingredients: [...prev.ingredients, addingIngredient] }))
        setAddingIngredient({ ingredient: null, amount: null })
    }

    const handleSave = async () => {
        const resp = await dispatch(id ? editDish(state) : createDish(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    useEffect(() => {
        if (id) {
            dispatch(getSingleDish(id))
        }
        return (() => {
            dispatch(clearSingleDish())
        })
    }, [id])

    useEffect(() => {
        if (singleDish) {
            setState(singleDish)
        }
    }, [singleDish])

    const handleRemoveIngredient = (ingredientLabel: string) => {
        setState(prev => ({ ...prev, ingredients: prev.ingredients.filter(i => i.ingredient.label !== ingredientLabel) }))
    }

    return <Modal black >
        <Flex column gap='1rem' >
            <Flex between width='100%' center >
                <TitleText weight='bold' >{id ? 'Edit' : 'Add'} Dish</TitleText>
                <CursorPointer onClick={closeModal} >
                    <CloseIcon />
                </CursorPointer>
            </Flex>
            <Flex width='100%' gap='1rem' >
                <Flex width='100%' column >
                    <Input labelText='Dish name' name='name' placeholder='Potato soup, grilled meat...' value={state.name} onChange={handleChange} invalid={invalidFields.includes('name') ? 'true' : ''} style={{ minWidth: '400px' }} />
                    <HonestSelectAsyncInput
                        link='food/management/meal/type'
                        name='mealType'
                        labelText='Meal Type'
                        placeholder='Breakfast...'
                        defaultValue={state?.mealType?.label}
                        onChange={handleSelect}
                        invalid={!state.mealType}
                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                    />

                    <HonestSelectInput
                        options={dietaryPreferences}
                        defaultValue={state.dietaryPreferences}
                        labelText='Dietary preference'
                        onChange={handleSelect}
                        name='dietaryPreferences'
                        multi
                        invalid={!state.dietaryPreferences?.length}
                    />

                    <HonestSelectAsyncInput
                        link='food/management/meal/supplier'
                        name='supplier'
                        labelText='Supplier'
                        placeholder='Supplier name'
                        defaultValue={state?.supplier?.label}
                        onChange={handleSelect}
                        invalid={!state.supplier}
                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id, isConnectedWithFoodInventory: i.isConnectedWithFoodInventory }))}
                        nomarg
                    />
                </Flex>
                {
                    state?.supplier?.isConnectedWithFoodInventory && <Flex width='100%' column gap='1rem' >
                        <HonestSelectAsyncInput
                            link='food/management/ingredient'
                            name='ingredient'
                            labelText='Ingredient'
                            placeholder='Milk, sugar...'
                            defaultValue={addingIngredient?.ingredient?.label}
                            onChange={handleIngredientSelect}
                            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id, unit: i.unit.name }))}
                            width='400px'
                        />
                        <Flex gap='1rem' alignEnd >
                            <Input name='amount' width='120px' labelText='Amount' placeholder='1, 2, 2.547...' value={addingIngredient.amount} type='number' onChange={handleAmount} nomarg />
                            <Button orange width='120' disabled={!addingIngredient.amount || !addingIngredient.ingredient} onClick={handleAddIngredient} >Add</Button>
                        </Flex>
                        <IngredientsList>
                            <BodyText>{state.ingredients.map(i => <Flex gap='1rem' >{i.amount + ' ' + i.ingredient.unit + ' ' + i.ingredient.label} <CursorPointer
                                onClick={() => handleRemoveIngredient(i.ingredient.label)}
                            >
                                <XIcon />
                            </CursorPointer></Flex>)}</BodyText>
                        </IngredientsList>
                    </Flex>
                }
            </Flex>
            <Flex width='100%' center justcenter >
                <Button orange disabled={!!invalidFields.length || (state.supplier?.isConnectedWithFoodInventory && !state.ingredients?.length)} onClick={handleSave} >Save</Button>
            </Flex>
        </Flex>
    </Modal>
}

export interface IDishesModal {
    id?: number
    name: string
    mealType: ISelectValue
    dietaryPreferences: ISelectValue[]
    supplier: ISelectValue & { isConnectedWithFoodInventory?: boolean }
    ingredients: {
        ingredient: ISelectValue & { unit?: string }
        amount: number
    }[]
}